import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Tabs, Layout, LocaleProvider } from 'antd';
import cx from 'classnames';
import './style/index.less';
import $$ from 'cmn-utils';
import config from '@/config';
import Toolbar from 'components/Toolbar';
import SearchBar from 'components/SearchBar';
import DataTable from 'components/DataTable';
import PageHelper from '@/utils/pageHelper';
import { OrgTree } from '@/routes/System/Org';
import TextShow from 'components/TextShow';
import {
  qryOrgList,
} from '../service';
import {
  getWinSize,
} from '@/utils/common';

const TabPane = Tabs.TabPane;
const { Content, Header, Footer } = Layout;
const Pagination = DataTable.Pagination

function noop() { }

export default class OrgSelectModal extends Component {
  static defaultProps = {
    title: window.language['org.selectOrg'],
    treeTitle: window.language['org.title'],
    multiple: false,//默认不支持多选
    initKeys: [],//初始化时的已选择的组织机构id数据
    initTitles: [],//初始化时的已选择的组织机构name数据
    initLevels: [],//初始化时的已选择的组织机构level数据
    prefixCls: 'antui-orgtree-selectmodal',
    visible: false,
    onCancel: noop,
    onOk: noop,
    footer: noop,
    loading: false,
    isClean: false,//默认不支持为空
    canSelectOperaterOrg: true,//能否选择当前登录用户的机构
  };

  static propTypes = {
    title: PropTypes.string,
    treeTitle: PropTypes.string,
    multiple: PropTypes.bool,
    initKeys: PropTypes.array,
    initTitles: PropTypes.array,
    initLevels: PropTypes.array,
    visible: PropTypes.bool,
    onCancel: PropTypes.func,
    onOk: PropTypes.func,
    modalOpts: PropTypes.object,
    className: PropTypes.string,
    isClean: PropTypes.bool,
    canSelectOperaterOrg: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.state = {
      visible: this.props.visible,
      selectedKeys: this.props.initKeys,//已选择的组织机构id数据
      selectedTitles: this.props.initTitles,//已选择的组织机构name数据
      selectedLevels: this.props.initLevels,//已选择的组织机构level数据
      pageData: PageHelper.create().initPage(1, 10),
    };
  }

  /**
   * 当组件要从界面上装载渲染的时候，就会调用 componentWillMount()，
   * 执行一次，在初始化render之前执行，
   * 如果在这个方法内调用setState，render()知道state发生变化，并且只执行一次
   */
  componentWillMount() {
    this.qryList();
  }

  /**
   * 当props发生变化时执行，初始化render时不执行，
   * 在这个回调函数里面，你可以根据属性的变化，通过调用this.setState()来更新你的组件状态，
   * 旧的属性还是可以通过this.props来获取,这里调用更新状态是安全的，并不会触发额外的render调用
   * 
   * @param {nextProps} nextProps 新的属性对象
   */
  componentWillReceiveProps(nextProps) {
    if ('visible' in nextProps) {
      this.setState({
        visible: nextProps.visible
      });
    }
  }

  onCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
      return;
    }
    this.setState({
      visible: false
    });
  };

  onOk = () => {
    const { onOk, isClean } = this.props;
    const { selectedKeys, selectedTitles, selectedLevels } = this.state;
    //未选择的组织机构
    if (selectedKeys.length === 0) {
      if (isClean === true) {
        onOk && onOk([], []);
      } else {
        const notice = config.notice;
        notice.warn(window.language['org.pleaseSelectOrg']);
        return;
      }
    }

    onOk && onOk(selectedKeys, selectedTitles, selectedLevels);
  };

  buildSearchParam = (pageData) => {
    let param = {
      name: pageData.filters.name || '',
      currentPage: pageData.pageNum,
      rowSize: pageData.pageSize
    }

    return param;
  }

  qryList = (data) => {
    let postParams = this.buildSearchParam(data ? data : this.state.pageData);

    qryOrgList(postParams).then(
      ({ code, msg, root, totalNum }) => {
        if (code === "200") {
          this.setState({
            pageData: this.state.pageData.setData(root, totalNum)
          });
        } else {
          const notice = config.notice;
          notice.error(window.language['responseCode.' + code]);
        }
      }
    ).catch((error) => {
      const notice = config.notice;
      notice.error(window.language['conmmon.search.error']);
    });
  }

  render() {
    const {
      title,
      treeTitle,
      multiple,
      className,
      onCancel,
      onOk,
      modalOpts,
      size,
      loading,
      full,
      isClean,
      canSelectOperaterOrg
    } = this.props;

    const { pageData, selectedKeys, selectedTitles, selectedLevels } = this.state;

    const classname = cx(className, 'antui-modalform', 'orgSelModal', 'show-modal', { 'full-modal': full });

    /** 模态框属性 */
    const modalProps = {
      className: classname,
      title: title,
      confirmLoading: loading,
      visible: this.state.visible,
      maskClosable: false,
      destroyOnClose: true,
      size,
      width: 1000,
      onCancel: this.onCancel,
      footer: [
        onCancel && (
          <Button key="back" onClick={this.onCancel}>
            {window.language['common.cancel']}
          </Button>
        ),
        onOk && (
          <Button key="submit" type="primary" onClick={this.onOk}>
            {window.language['common.ok']}
          </Button>
        )
      ],
      ...modalOpts
    };

    /** 组织机构树属性 */
    const orgTreeProps = {
      showSearch: true,
      showToolbar: false,
      selectSyncToCheck: true,
      disableRoot: true,
      title: treeTitle,
      searchPlaceholder: window.language['common.orgTipContent1'],
      checkable: multiple,//支持多选，则显示checkbox
      multiple: multiple,//是否支持多选
      checkedKeys: selectedKeys,//已勾选节点key数组
      selectedKeys: selectedKeys,//已点选节点key数组
      isClean: isClean,//是否支持清除
      canSelectOperaterOrg: canSelectOperaterOrg,//能否选择当前登录用户的机构
      onChange: (targetKeys, targetTitles, targetLevels, targetNodes) => {
        this.setState({
          selectedKeys: targetKeys,//已选择的组织机构id数据
          selectedTitles: targetTitles,//已选择的组织机构name数据
          selectedLevels: targetLevels,//已选择的组织机构level数据
        });
      }
    }

    const columns = [
      {
        title: window.language['org.name'],
        name: 'name',
        tableItem: {
          width: 150,
        },
        searchItem: {},
      },
      {
        title: window.language['org.remark'],
        name: 'remark',
        tableItem: {
          width: 150,
          render: (text) => {
            if (text) {
              const textShowProps = {
                content: text,
                length: 15,
              }
              return (<TextShow {...textShowProps} />);
            }
          }
        }
      },
      {
        title: window.language['org.updater'],
        name: 'updater.username',
        tableItem: {
          width: 120,
        }
      },
      {
        title: window.language['org.updateTime'],
        name: 'updateTime',
        tableItem: {
          width: 120,
        }
      },
    ];

    /** 搜索条属性 */
    const searchBarProps = {
      columns,
      onSearch: (values) => {
        this.qryList(pageData.filter(values));
      }
    };

    let scrollY = 310;

    if(getWinSize().winWidth >= 1920){
      scrollY = 310;
    } else if(getWinSize().winWidth >= 1440){
      scrollY *= 0.69;
    } else if(getWinSize().winWidth >= 1366){
      scrollY *= 0.65;
    } else if(getWinSize().winWidth >= 1280){
      scrollY *= 0.61;
    } else {
      scrollY *= 0.5;
    }

    let contentHeight = scrollY + 55;

    /** 表格属性 */
    const dataTableProps = {
      loading,
      columns,
      rowKey: 'id',
      dataItems: pageData,
      selectType: multiple ? 'checkbox' : 'radio',//是否支持多选
      showNum: false,
      isScroll: true,
      //pageSize:20,
      scroll: { y: scrollY },
      selectedRowKeys: selectedKeys,
      onChange: ({ pageNum = pageData.pageNum, pageSize = pageData.pageSize }) => {
        let { filters: { name = "" } } = pageData.jumpPage(pageNum, pageSize);
        this.qryList(pageData.jumpPage(pageNum, pageSize));

      },
      onSelect: (keys, rows) => {
        //获取当前登录用户所属机构的PID
        const operaterOrgId = $$.getStore("user").org.id;

        let targetKeys = [];
        let targetTitles = [];
        let targetLevels = [];

        rows.forEach(item => {
          //不能选择当前登录用户的机构
          if (!canSelectOperaterOrg && operaterOrgId == item.id) {
            return;
          }

          targetKeys.push(item.id);
          targetTitles.push(item.name);
          targetLevels.push(item.level);
        });

        this.setState({
          selectedKeys: targetKeys,//已选择的组织机构id数据
          selectedTitles: targetTitles,//已选择的组织机构name数据
          selectedLevels: targetLevels,//已选择的组织机构level数据
        });
      },
      rowSelection: {
        getCheckboxProps: record => {
          //获取当前登录用户所属机构的PID
          const operaterOrgId = $$.getStore("user").org.id;

          return ({
            disabled: !canSelectOperaterOrg && operaterOrgId == record.id//不能选择当前登录用户的机构
          })
        }
      }
    }

    let tabPaneHeight = 600;

    if(getWinSize().winWidth >= 1920){
      tabPaneHeight = 500;
    } else if(getWinSize().winWidth >= 1440){
      tabPaneHeight *= 0.69;
    } else if(getWinSize().winWidth >= 1366){
      tabPaneHeight *= 0.65;
    } else if(getWinSize().winWidth >= 1280){
      tabPaneHeight *= 0.61;
    } else {
      tabPaneHeight *= 0.5;
    }

    return (
      <Modal {...modalProps}>
        <LocaleProvider locale={window.systemLanguage}>
          <Tabs defaultActiveKey="1" className="custom-tabs">
            <TabPane tab={window.language['common.grapMode']} key="1" style={{ height: tabPaneHeight }}>
              <OrgTree {...orgTreeProps} />
            </TabPane>
            <TabPane tab={window.language['common.listMode']} key="2" style={{ height: tabPaneHeight }}>
              <Layout>
                <Header>
                  <Toolbar
                    pullDown={
                      <SearchBar type="grid" {...searchBarProps} />
                    }
                  >
                  </Toolbar>
                </Header>
                <Content className="content-list" style={{ height: contentHeight }}>
                  <DataTable {...dataTableProps} />
                </Content>
                <Footer>
                  <Pagination {...dataTableProps} />
                </Footer>
              </Layout>
            </TabPane>
          </Tabs>
        </LocaleProvider>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/routes/System/Org/components/OrgSelectModal.js